import { TextField } from "@material-ui/core"
import { Autocomplete } from "@material-ui/lab"
import { useSelector, useDispatch } from "react-redux"
import { addPaqueteAction, obtenerPaquetesAction, addItemsAction, resetStateAction, resetPenalizacionAction } from "../../../../ducks/cambioPaqueteDuck"
import handleRenderOption from "./handleRenderOption"
import { useEffect } from "react"

const InitialValuePaquete = {
    Nombre: "",
    ClavePaquete: "0",
}

const CbPaquete = () => {
    const { categoria, listaPaquetes, paquete, cantidadPasajeros } = useSelector(store => store.cambiosPaquete)
    const dispatch = useDispatch()
    useEffect(() => {
        dispatch(obtenerPaquetesAction({ IdCategoria: categoria.IdCategoriaPaquete }))
    }, [dispatch, categoria.IdCategoriaPaquete])
    const getOptionHangle = (event, valor) => {
        dispatch(resetPenalizacionAction())
        dispatch(resetStateAction())
        if (valor) {
            dispatch(addPaqueteAction({ paquete: valor }))
            let arraItems = []
            let itemPaquete = {
                id: valor.envioPaqueteProveedor?.IdObjeto,
                name: valor.Nombre,
                price: valor.PrecioPublico,
                currency: valor.Moneda?.Clave,
                type: "PAQUETE",
                quantity: cantidadPasajeros
            }
            arraItems.push(itemPaquete)
            dispatch(addItemsAction({listaItem: arraItems}))
           
        } else {
            dispatch(addPaqueteAction({ paquete: InitialValuePaquete }))
            dispatch(addItemsAction({listaItem: []}))
        }
    }
    return (
        <div style={{ margin: "2% 0" }}>
            <Autocomplete
                value={paquete}
                id={`id-auto-Paquete`}
                options={listaPaquetes.sort((a, b) => a.Nombre > b.Nombre)}
                getOptionLabel={(option) => {
                    return `${option.Nombre}`
                }}
                style={{
                    width: "97%",
                    margin: "2% 0",
                    paddingBottom: "0",
                    fontWeight: "500",
                }}
                disabled={listaPaquetes.length > 0 ? false : true}
                onChange={getOptionHangle}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        label="Paquetes"
                        variant="outlined"
                        style={{ width: "100%" }}
                        name="paquetes"
                    />
                )}
                renderOption={handleRenderOption}
            />
        </div>
    )
}
export default CbPaquete